import { useEffect, useState, useCallback } from 'react';
import { canUseApp } from '@/auth/AuthContext';
import { plannerApi } from '@/pages/planner/plannerApi';

/** Polls the planner overdue + due-soon alert count for planner-enabled users. */
export function usePlannerAlerts(user) {
  const [data, setData] = useState({ total: 0, overdue_count: 0, due_soon_count: 0, my_open_count: 0, my_blocked_count: 0, my_open: [] });
  const enabled = canUseApp(user, 'planner');

  const refresh = useCallback(async () => {
    if (!enabled) { setData({ total: 0, overdue_count: 0, due_soon_count: 0, my_open_count: 0, my_blocked_count: 0, my_open: [] }); return; }
    try {
      // plannerApi 経由にして、ヘッダー・ランチャー・プロジェクト画面で
      // 同じ取得を使い回す（直接 axios だと同じ GET が何本も出る）。
      setData((await plannerApi.alerts()) || { total: 0 });
    } catch (_e) { /* ignore transient errors */ }
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [refresh, enabled]);

  return data;
}
